import { TileBodyHeaderV2 } from 'common/tile/tile-body-header-v2.js';
import { Tile } from 'common/tile/tile.js';
import { IModule } from 'redux-state/layout/types.js';
import { setDefaultTitle } from 'utilities/text/titleDefault.js';
import { GeneralInformationComponent } from './factory/general-information.js';

interface IRoadInformation {
  text: string[] | string;
  status: string;
}

export const RoadInformation = ({ config, isDrawer, modulePath }: IModule<IRoadInformation>) => {
  const { status, text } = config;

  return (
    <Tile dataModule="road-information" config={config}>
      <div className="Tile-body">
        <TileBodyHeaderV2
          isDrawer={isDrawer}
          modulePath={modulePath}
          config={setDefaultTitle(config, 'Road information')}
        />

        <GeneralInformationComponent headers={[{ icon: 'roads', title: 'Road Status', status }]} text={text} />
      </div>
    </Tile>
  );
};
